module.exports = __webpack_public_path__ + "img/sign-23.617c4cf4.jpg";